import { keyOf, combineActions, extractCommands } from './helpers.js'
import { settings } from '../../../settings/settings-util'
import ivaCmds         from './commands/iva'
import pageCmds        from './commands/webpage'
import flowCmds        from './commands/flow-control'
import logicCmds       from './commands/logic'
import generalCmds     from './commands/general'
import watch           from 'redux-watch'

export default function CommandActionHandler(passedSettings, ...customCommands) {
    let allCommands = [generalCmds, flowCmds, logicCmds, pageCmds, ivaCmds, ...customCommands];
    let _store      = { dispatch: () => { }, getState: () => ({}), subscribe: () => { } };
    let dispatch    = event => _store.dispatch(event);
    let hasLoaded   = false;
    let selectedSettings        = passedSettings || settings;

    async function initialize(store, initializationPromises) {
        _store = store;

        await initializationPromises.onLaunch; 
        if (!hasLoaded) {
            let SL     = selectedSettings.stateLocations.CommandAction;
            let acts   = (_store.getState()[SL.Base] || {})[SL.PageLoadActions] || [];
            let action = combineActions(...acts);
            if (action.length) { setTimeout(() => evaluate(action), 500); }
            dispatch({ type: 'CLEAR_PAGE_LOAD_ACTIONS', payload: {} });
            hasLoaded = true;
        }
    }

    function getReducer() {
        return (state={}, dispatchedAction) => {
            let { type, payload } = dispatchedAction;
            let { action, index } = (payload || {});
            let PLA  = selectedSettings.stateLocations.CommandAction.PageLoadActions;
            let curr = state[PLA];
            let next = (a) => Object.assign({}, state, { [PLA]: a });
            return (type ===  'CLEAR_PAGE_LOAD_ACTIONS') ? next([]) :
                   (type ===    'ADD_PAGE_LOAD_ACTION' ) ? next([...curr, action]) :
                   (type === 'REMOVE_PAGE_LOAD_ACTION' ) ? next(curr.map((v, i) => (i === index) ? [] : v))
                                                         : state;
        };
    }

    function doesHandle(message) {
        let t = (message && message.messageType)
        let c = (settings && selectedSettings.messageConstants);
        return (t && (t === c.converseRequest || t === c.appeventRequest || t === c.requestUnitRequest /*|| t === c.getHistoryRequest*/));
    }

    function process(message) {
        if (!doesHandle(message)) { return message; }
        let resp     = message.response;
        let response = Array.isArray(resp) ? resp.map(processResponse) : processResponse(resp);
        return Object.assign({}, message, { response });
    }

    function processResponse(resp) {
        let action = getAction(resp);
        evaluate(action, resp);
        return resp;
    }

    function processLink(resp, link, doNav = true, origin = null) {
        let sections   = (resp.displayLinkCollection || {}).Sections || [];
        let links      = [].concat(...sections.map(s => s.Links || []));
        let actionIdx  = links.reduce((idx, L, i) => (L === link) ? i : idx, -1);
        let actionKey  = (actionIdx >= 0) ? 'LinkActions' : 'NavAction';
        let mainAction = getAction(link, resp, actionKey, actionIdx);

        if (!doNav) {
            return evaluate(mainAction, resp, link, origin);
        }

        let navAction = [];
        let consts = selectedSettings.navConstants;
        switch(link.TargetType || consts.targetTypes.url) {
            case consts.targetTypes.input:
                let text     = link.InputText || '';
                navAction    = ['Converse', text, link.DisplayText || ''];
                break;
            case consts.targetTypes.unit:
                let unitId   = (link.Metadata || {}).UnitUID || '';
                navAction    = ['Unit', unitId, link.DisplayText || ''];
                break;
            case consts.targetTypes.url:
                let url      = link.UrlAddress || '';
                let type     = link.LinkNavigationType;
                let isMain   = (type === consts.linkTypes.mainPage);
                let isPopup  = (type === consts.linkTypes.popup);
                let features = link.WindowFeatures || consts.defaultWindowFeatures;
                navAction    = (isPopup || isMain) ? ['Navigate', url, isPopup, features] : [];
                break;
            default: break;
        }

        let allActions = combineActions(navAction, mainAction);
        return evaluate(allActions, resp, link, origin);
    }

    function getAction(src, resp = src, key = 'Action', idx = -1) {
        let main = (src && src.Action) ? [src.Action] : [];
        let  ras = (resp && resp.responseActions) || [];
        let cRas = ras.filter(a => keyOf(a.Name || a.name) === 'command');
        let cmds = cRas.map(a => a[key])
                       .map(a => (idx >= 0) ? a[idx] : a);
        return combineActions(...main, ...cmds);
    }

    function evaluate(expr, resp, src = resp, origin = null) {
        let context  = { settings, dispatch, resp, src, origin, evaluate: _eval };
        let commands = extractCommands(context, ...allCommands);
        let { get }  = commands;

        function _eval(expr) {
            if (!Array.isArray(expr) || expr.length < 1) {
                return SafeResult(expr);
            }
            let [op, ...args] = expr;
            let opVal  = _eval(op);
            let opFunc = (typeof opVal === 'function');
            let name   = !opFunc && keyOf(opVal);
            let cmd    = (opFunc && opVal) || commands[name];
            let values = (cmd && cmd.macro) ? args : args.map(_eval);
            let isFunc = (typeof cmd === 'function');
            return (isFunc) ? SafeResult(cmd, values)
                            : SafeResult(get, [opVal, ...values]);
        }

        return _eval(expr);
    }

    function SafeResult(f, args) {
        try {
            let x = (args) ? f(...args) : f;
            return (typeof x === 'undefined') ? null : x;
        }
        catch(ex) { return ex; }
    }

    return { initialize, getReducer, doesHandle, process, processResponse, processLink, getAction, combineActions, evaluate };
}

CommandActionHandler.getDefaultSettings = () => settings;


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/command-action-handler/src/command-action-handler.js